import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AppShell from './components/AppShell';
import ProtectedRoute from './components/ProtectedRoute';
import Accounts from './pages/Accounts';
import ConnectMeta from './pages/ConnectMeta';
import Login from './pages/Login';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Settings from './pages/Settings';
import './App.css';

function AuthRedirect() {
  const token = localStorage.getItem('auth_token');
  return <Navigate to={token ? '/accounts' : '/login'} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route
          path="/"
          element={(
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          )}
        >
          <Route index element={<AuthRedirect />} />
          <Route path="accounts" element={<Accounts />} />
          <Route path="connect-meta" element={<ConnectMeta />} />
          <Route path="settings" element={<Settings />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
